module.exports = __webpack_public_path__ + "static/img/1-_08.e8685fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1-_08.png
// module id = jS1F
// module chunks = 0